// NotificationStatusBadge.jsx
import React from "react";

const statusMap = {
  new:      { label: "New",      bg: "bg-emerald-100 text-emerald-800", dot: "bg-emerald-500" },
  unread:   { label: "Unread",   bg: "bg-teal-100 text-teal-800",      dot: "bg-teal-500" },
  read:     { label: "Read",     bg: "bg-stone-100 text-stone-700",    dot: "bg-stone-300" },
  archived: { label: "Archived", bg: "bg-amber-100 text-amber-800",    dot: "bg-amber-400" },
  active:   { label: "Active",   bg: "bg-green-100 text-green-800",    dot: "bg-green-500" },
  inactive: { label: "Inactive", bg: "bg-red-100 text-red-800",        dot: "bg-red-500" }
};

export default function NotificationStatusBadge({ status = "new" }) {
  // Normalize status: lowercase for lookup
  const normalizedStatus = status?.toString().toLowerCase() || "read";
  const s = statusMap[normalizedStatus] || statusMap.read;

  return (
    <div className={`inline-flex items-center gap-3 px-3 py-1 rounded-full ${s.bg} text-sm font-medium`}>
      <span className={`w-2 h-2 rounded-full ${s.dot}`} />
      <span>{s.label}</span>
    </div>
  );
}
